import React, {useState, useEffect} from "react";
import ReactPaginate from 'react-paginate';
import ReviewSummary from './Reviews/Summary';
import ReviewItem from './Reviews/Review';
import ReviewForm from './Reviews/ReviewForm';
const ListingReviews = (props) => {
  const { listing, currentUser = {} } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [reviews, setReviews] = useState([])
  const [reviewsMeta, setReviewsMeta] = useState([])
  const fetchReviews = async (page=1) => {
    setIsLoading(true)
    fetch(`/listing/${listing.slug}/reviews?page=${page}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
        ?.content,
      },
    }).then((resp) => {
      return resp.json();
    }).then((resp) => {
      setIsLoading(false);
      setReviews(resp.resources);
      setReviewsMeta(resp.meta);
    }).catch((error) => {
      console.log('error', error);
      setIsLoading(false);
    })
  }
  const handlePageChange = (pg) => {
    fetchReviews(+pg.selected + 1)
  }
  const handleSubmitted = (e) => {
    fetchReviews();
  }
  useEffect(() => {
    fetchReviews()
  }, []);
  return (
    <React.Fragment>
      <div className="utf_listing_section">
      <h3 className="utf_listing_headline_part margin-top-75 margin-bottom-20">Reviews 
      {reviewsMeta.total > 0 && <span>({reviewsMeta.total})</span>
      }
    </h3>
      <div className="clearfix"></div>
      <ReviewSummary
        listing={listing}
        reviewsMeta={reviewsMeta}
      />
      <div className="comments utf_listing_reviews">
        <ul>
          {
            reviews.map((review) => (
              <ReviewItem key={review.id} review={review} listing={listing}/>
            ))
          }
        </ul>
        </div>
        <div className="clearfix"></div>
        {
          reviewsMeta.pages > 1 &&  <div className="row">
          <div className="col-md-12">

            <div className="utf_pagination_container_part margin-top-30">
            
          
              <nav className="pagination">
              <ReactPaginate
              breakLabel="..."
              previousLabel={<i className="sl sl-icon-arrow-left"></i>}
              nextLabel={<i className="sl sl-icon-arrow-right"></i>}
              pageRangeDisplayed={3}
              pageCount={reviewsMeta.pages}
              renderOnZeroPageCount={null}
              onPageChange={handlePageChange}
            />
              
              </nav>
            </div>
          </div>
        </div>
        }
       
      </div>
      <ReviewForm
        listing={listing}
        currentUser={currentUser}
        onSubmitted={handleSubmitted}
      />
    </React.Fragment>
  );
};

export default ListingReviews;
